import { ROUTES } from "@/lib/constants";

const WORKSPACE_PREFIX = ROUTES.ASSISTANT_WORKSPACE.replace(":questId", "");

/**
 * A workspace chat lives under /assistant/w/… but belongs to Chats, not to the
 * assistant — so the default NavLink prefix match would light the wrong item.
 */
export function isNavItemActive(to: string, pathname: string): boolean {
  const inWorkspace = pathname.startsWith(WORKSPACE_PREFIX);
  if (to === ROUTES.CHATS) return pathname.startsWith(ROUTES.CHATS) || inWorkspace;
  if (to === ROUTES.ASSISTANT) return pathname.startsWith(ROUTES.ASSISTANT) && !inWorkspace;
  return pathname === to || pathname.startsWith(`${to}/`);
}
